import { mpfRListsHttp } from '../../api/mpf-r-lists-http'
import { isArchivedFilter } from '../data'

interface DueOutProcessFlowMetadata {
  AssignTo: boolean
  AssignToOptions: string
  Cancel: boolean
  Close: boolean
  Complete?: boolean
  Respond: boolean
  Role: string
  Section: string
  StatusCode: string
  UserType: string
}
interface DueOutProcessFlowMetadataArgs {
  isArchivedFilter: false | null | true
  isAscending?: boolean
  orderBy?: string
}
const COLUMN_NAMES = {
  AssignTo: 'AssignTo',
  AssignToOptions: 'AssignToOptions',
  Cancel: 'Cancel',
  Close: 'Close',
  Complete: 'Complete',
  Respond: 'Respond',
  Role: 'Role',
  Section: 'Section',
  StatusCode: 'StatusCode',
  UserType: 'UserType',
}
const LIST_NAME = 'DueOutProcessFlowMetadataList'

const getDueOutProcessFlowMetadata = async (
  args: DueOutProcessFlowMetadataArgs
): Promise<DueOutProcessFlowMetadata[]> => {
  const list = await mpfRListsHttp().getList(LIST_NAME)
  const filter = isArchivedFilter(args.isArchivedFilter)
  const ascending = args?.isAscending ?? true
  const orderBy = args?.orderBy ?? COLUMN_NAMES.StatusCode

  const items = await list
    .query()
    .filter(filter)
    .select(
      COLUMN_NAMES.AssignTo,
      COLUMN_NAMES.AssignToOptions,
      COLUMN_NAMES.Cancel,
      COLUMN_NAMES.Close,
      COLUMN_NAMES.Complete,
      COLUMN_NAMES.Respond,
      COLUMN_NAMES.Role,
      COLUMN_NAMES.Section,
      COLUMN_NAMES.StatusCode,
      COLUMN_NAMES.UserType
    )
    .orderBy([{ ascending: ascending, orderBy: orderBy }])
    .get()

  return [...items] as DueOutProcessFlowMetadata[]
}

export {
  COLUMN_NAMES,
  type DueOutProcessFlowMetadata,
  type DueOutProcessFlowMetadataArgs,
  LIST_NAME,
  getDueOutProcessFlowMetadata,
}
